import {
  AttachmentPipelineStatus,
  IAttachmentPipelineHandle,
} from './attachment.interface';

import {
  IAttachmentUploadUrlResponse,
  IUploadedAttachment,
  uploadAttachmentToStorage,
} from 'utils/attachments';

function startAttachmentPipeline(
  file: File,
  requestUploadUrl: (
    fileName: string,
    contentType: string,
  ) => Promise<IAttachmentUploadUrlResponse>,
  onStatusChange: (
    status: AttachmentPipelineStatus,
    uploaded?: IUploadedAttachment,
  ) => void,
): IAttachmentPipelineHandle {
  const controller = new AbortController();
  let isCancelled = false;

  uploadAttachmentToStorage(file, requestUploadUrl, controller.signal)
    .then(uploaded => {
      if (!isCancelled) {
        onStatusChange('ready', uploaded);
      }
    })
    .catch(() => {
      if (!isCancelled) {
        onStatusChange('error');
      }
    });

  return {
    cancel: (): void => {
      isCancelled = true;
      controller.abort();
    },
  };
}

export { startAttachmentPipeline };
